<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <div class="tabs">
      <ul>
        <li class="is-active"><a>Daily</a></li>
        <li>
          <router-link
            :to="{ name: 'reportWeekly', params: { projectId: projectId } }"
          >
            Weekly
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'reportMonthly', params: { projectId: projectId } }"
          >
            Monthly
          </router-link>
        </li>
      </ul>
    </div>
    <h5 class="title is-5">{{ $t("reports.daily") }}</h5>
    <DailyGraph :tenant-id="tenantId" :project-id="projectId"></DailyGraph>
    <hr />
    <DailyReports :tenant-id="tenantId" :project-id="projectId"></DailyReports>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb";
import DailyGraph from "@/components/reports/dailyGraph.vue";
import DailyReports from "@/components/reports/dailyReports.vue";
import { computed, ref } from "@vue/reactivity";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    Breadcrumb,
    DailyReports,
    DailyGraph,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const breadcrumb = ref([
      {
        title: "Home",
        path: {
          name: "dashboard",
          params: { projectId: route.params.projectId },
        },
      },
      { title: "Report", path: "#", isActive: true },
    ]);

    return {
      tenantId: computed(() => store.getters.tenantId),
      projectId: computed(() => route.params.projectId),
      breadcrumb,
    };
  },
};
</script>
